import { ConnectProto } from "@racoon/api";

/** Archive has no status of its own in the contract — INACTIVE is it. */
export const isTruckArchived = (truck?: { status?: ConnectProto.TruckStatus }) =>
  truck?.status === ConnectProto.TruckStatus.INACTIVE;

/** The truck's type entity wins over the legacy `type` field, as on Автопарк. */
export const truckTypeOf = (truck: ConnectProto.Truck) =>
  truck.truckType?.type || truck.type || ConnectProto.TruckType.UNDEFINED;

/** The fleet's own type order (as on the Автопарк page); untyped trucks come last. */
export const TRUCK_TYPE_ORDER = [
  ConnectProto.TruckType.MSW,
  ConnectProto.TruckType.CONSTRUCTION,
  ConnectProto.TruckType.DOUBLE_CONTAINER,
  ConnectProto.TruckType.TIPPER,
  ConnectProto.TruckType.LIQUID_WASTE,
  ConnectProto.TruckType.LOADER_CRANE,
  ConnectProto.TruckType.UNDEFINED,
];
